<template>
  <div class="w-100">
    <div class="d-flex mt-3 w-50 ml-auto mr-auto">
      <date-range-picker
        :locale-data="{
          'firstDay': 1,
          'format': 'dd-mm-yyyy',
          'daysOfWeek': [$t('ui.daysOfWeek.sun'), $t('ui.daysOfWeek.mon'), $t('ui.daysOfWeek.tue'), $t('ui.daysOfWeek.wed'), $t('ui.daysOfWeek.thur'), $t('ui.daysOfWeek.fri'), $t('ui.daysOfWeek.sat')],
          'monthNames': [$t('ui.monthNames.jan'), $t('ui.monthNames.feb'), $t('ui.monthNames.mar'), $t('ui.monthNames.apr'), $t('ui.monthNames.may'), $t('ui.monthNames.jun'), $t('ui.monthNames.jul'), $t('ui.monthNames.aug'), $t('ui.monthNames.sep'), $t('ui.monthNames.oct'), $t('ui.monthNames.nov'), $t('ui.monthNames.dec')],
        }"
        class="w-50"
        :singleDatePicker="false"
        :timePicker="false"
        :showWeekNumbers="false"
        :showDropdowns="false"
        :autoApply="true"
        v-model="date"
        :linkedCalendars="true" />

      <d-button
        theme="primary"
        class="ml-3 w-50"
        :disabled="historyLoadInProgress && !loadError"
        @click.prevent="loadData()">
        <template v-if="!historyLoadInProgress">
          {{ $t('product.stateHistory.loadHistory') }}
        </template>
        <template v-else>
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </template>
      </d-button>
    </div>

    <d-alert
      theme="warning"
      :show="loadError"
      class="text-center mt-3">
      {{  $t('ui.dataLoadingFailed') }}
    </d-alert>

    <table
      v-if="loaded && !loadError"
      class="table mt-3 mb-0 full-width">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0" style="width: 200px;">{{ $t('product.stateHistory.date') }}</th>
          <th scope="col" class="border-0 text-center" style="width: 120px;">{{ $t('product.stateHistory.quantity') }}</th>
          <th scope="col" class="border-0" style="width: 250px">{{ $t('product.stateHistory.type') }}</th>
          <th scope="col" class="border-0">{{ $t('product.stateHistory.order') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) of reversedItems"
          :key="'history-item-' + index">
          <td class="align-middle">
            {{ item.date.split('.')[0].split('T').join(' ') }}
          </td>
          <td class="align-middle text-center">
            {{ item.quantity }} {{ $t('ui.piecesAbbr') }}
          </td>
          <td class="align-middle">
            {{ getTypeName(item.type)}}
          </td>
          <td class="align-middle">
            <a
              v-if="item.order"
              :href="orderBaseUrl + 'zamowienia/edycja/' + item.order.id">
              {{ item.order.order_name }}
            </a>
            <span v-else>
              &mdash;
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AppConfig from './../../.env';
import FormUtils from './../../utils/FormUtils.js';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'product-state-history',
  props: [
    'productID'
  ],
  components: {
    'date-range-picker': DateRangePicker
  },
  computed: {
    reversedItems () {
      return JSON.parse(JSON.stringify(this.items)).reverse();
    },
    startDate () {
      return [this.date.startDate.getFullYear(), this.date.startDate.getMonth() + 1, this.date.startDate.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
    },
    endDate () {
      return [this.date.endDate.getFullYear(), this.date.endDate.getMonth() + 1, this.date.endDate.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
    },
    orderBaseUrl () {
      return AppConfig.additionalConfig[AppConfig.useConfig].apiServerUrl;
    }
  },
  data () {
    return {
      items: [],
      loaded: false,
      loadError: false,
      historyLoadInProgress: false,
      date: {
        startDate: null,
        endDate: null
      }
    };
  },
  mounted () {
    this.qty = this.maxQty;
    this.date = {
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date()
    };
  },
  methods: {
    loadData () {
      this.loadError = false;
      this.historyLoadInProgress = true;

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/products/history/item/' + parseInt(this.productID, 10),
        loadedKey: 'loaded',
        params: {
          date_from: this.startDate,
          date_to: this.endDate
        },
        outputKey: 'items',
        errorKey: 'loadError',
        successAction: () => {
          this.loadError = false;
          this.historyLoadInProgress = false;
        },
        failAction: () => {
          this.historyLoadInProgress = false;
        },
        catchAction: () => {
          this.historyLoadInProgress = false;
        }
      });
    },
    getTypeName (type) {
      return this.$t('product.stateHistory.itemType.' + type);
    }
  }
}
</script>
